// extracted by mini-css-extract-plugin
export var dataCell = "_r6-2";
export var dataRow = "_r6-0";
export var headerRow = "_r6-1";